<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert v-show="newNotify.isNewNotify" border="left" close-text="Close Alert" color="green accent-4" dark @click="newNotify.isNewNotify = false">
      {{ newNotify.text }}
    </v-alert>

    <v-row>
      <v-col cols="12">
        <v-card class="pa-md-3">
          <v-card-title class="headline">
            <v-icon color="#3795d2" large left>
              mdi-map
            </v-icon>
            <span class="text-h6 font-weight-light">Mapa de Empresas</span>
          </v-card-title>

          <v-card-text>
            <MglMap :accessToken="accessToken" :mapStyle.sync="mapStyle" :zoom.sync="zoom" :center.sync="centerMap" style="width: 100%; height: 600px;" @load="iniciarMapa">
              <MglMarker v-for="(localizacaoSelecionada, i) in listaLocalizacoesEmpresas" :key="i" :coordinates="[localizacaoSelecionada.longitude, localizacaoSelecionada.latitude]" :color="localizacaoSelecionada.corPing">
                <MglPopup anchor="top">
                  <v-card elevation="0">
                    <v-card-text style="max-height: 260px; overflow-y: auto;">
                      <v-row v-for="(empresaSelecionada, j) in localizacaoSelecionada.listaEmpresas" :key="j">
                        <p>Nome da empresa: {{ empresaSelecionada.nomeFantasia }}</p>
                        <p>Cevs: {{ empresaSelecionada.cevs }}</p>
                        <p>Endereço: {{ empresaSelecionada.endereco }}</p>

                        <v-divider v-if="j < localizacaoSelecionada.listaEmpresas.length - 1" :key="`${j}-divider`" class="mb-4"></v-divider>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </MglPopup>
              </MglMarker>
            </MglMap>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import { MglMap, MglPopup, MglMarker } from "vue-mapbox";
import "mapbox-gl/dist/mapbox-gl.css";
let mapa = null;

export default {
  components: {
    MglMap,
    MglPopup,
    MglMarker,
  },

  data() {
    return {
      accessToken: "pk.eyJ1IjoiZmVpb2t1biIsImEiOiJjanJtOWpsdzcwaDJsNDR0Mmh0ZGV1bzR2In0.XWAmqcgxDNyjq3Mg2XDE0g",
      mapStyle: "mapbox://styles/mapbox/streets-v11",
      centerMap: [-47.287163, -23.2695046],
      zoom: 16,
      colorMaker: "green",
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
      newNotify: {
        isNewNotify: false,
        text: "",
      },
      listaLocalizacoesEmpresas: [],
    };
  },

  methods: {
    async iniciarMapa(map) {
      mapa = map.map;
      try {
        const enderecoLicenca = await axios.get("/listarEmpresasPorEndereco", this.config);
        this.listaLocalizacoesEmpresas = enderecoLicenca.data;
      } catch (error) {
        console.log(error);
      }
    },

    async centralizarMapa(longitude, latitude) {
      mapa.flyTo({
        style: "mapbox://styles/mapbox/streets-v11",
        center: [longitude, latitude],
      });
    },
  },
};
</script>
